import { Flex, Modal } from 'antd';
import { Heading } from '@/components/Heading';
import { Role } from '@/types';
import RoleForm from './RoleForm';
import { useTranslation } from 'react-i18next';

interface Props {
  roleUID?: string;
  roleData?: Role;
  onClose: () => void;
}
const AddRoleModal = ({ roleUID, roleData, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      className='rounded-[20px] bg-white border   border-customGrayShade3'
      title={
        <Flex style={{ borderBottom: '1px solid #E1E1E3', paddingBottom: '1rem' }}>
          <Heading
            title={roleUID ? t('update_role') : t('add_new_role')}
            upperCase
            fontSize='text-lg'
            fontWeight='font-semibold'
          />
        </Flex>
      }
      width={700}
      centered
      footer={null}
      open={roleUID !== undefined}
      onOk={onClose}
      onCancel={onClose}
      destroyOnClose
    >
      <RoleForm roleUID={roleUID} roleData={roleData} onClose={onClose} />
    </Modal>
  );
};

export default AddRoleModal;
